import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
	Button,
	VStack,
	List,
	ListItem,
	ListIcon,
	Flex,
	Image,
	Text,
} from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import noKeyImage from '../../../src/assets/images/png/no-key.png';

import { LockIcon } from '@chakra-ui/icons';
const MintInfoModal = ({ isOpen, onClose }) => {
	const navigate = useNavigate();
	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>
					<Flex flexFlow={"row"} gap={2} justifyContent={"center"} pt={4}>
						<LockIcon color={"#DD6B20"} />
						<Text>Unlock Premium Features</Text>
					</Flex>

				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Flex alignContent={"center"} justifyContent={"center"}>
						<Image
							src={noKeyImage}
							maxW="200px"
							className="shake-animation" // Примените CSS класс
						/>
						{/* <Image src={mintKeyImage} maxW={"220px"} borderRadius={15} /> */}
					</Flex>

					<VStack
						// bg={useColorModeValue('gray.50', 'gray.700')}
						py={4}
						borderBottomRadius={'xl'}
						spacing={4}
						align="center"
						mt={4}
						mr={4}
						ml={4}
					>
						<List spacing={3} textAlign="start" px={16}>
							<ListItem>
								<ListIcon as={FaCheckCircle} color="green.500" />
								Multiple rating requests
							</ListItem>
							<ListItem>
								<ListIcon as={FaCheckCircle} color="green.500" />
								Chart of daily marks history
							</ListItem>
							<ListItem>
								<ListIcon as={FaCheckCircle} color="green.500" />
								Custom Check Rank
							</ListItem>
							<ListItem>
								<ListIcon as={FaCheckCircle} color="green.500" />
								Saving data to CSV
							</ListItem>
							<ListItem>
								<ListIcon as={FaCheckCircle} color="green.500" />
								All future features
							</ListItem>
						</List>
					</VStack>
					<Flex w="100%" pt={4} alignItems={"center"} justifyContent={"center"} pb={8}>
						<Button
							w="80%"
							colorScheme="orange"
							variant="solid"
							onClick={() => {
								window.gtag('event', 'button_click', {
									event_category: 'Button',
									event_label: 'go_mint_page_click',
								});
								navigate('/mint-key')
							}}
						>
							Mint Access Key
						</Button>
					</Flex>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default MintInfoModal;
